"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _popover = _interopRequireDefault(require("antd/lib/popover"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _Arrow = _interopRequireDefault(require("../Arrow"));

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

require("./styles.less");

var styles = {
  "popover": "meepshop-meep-ui__submenu-dropdownMenu-styles__popover",
  "groupPopover": "meepshop-meep-ui__submenu-dropdownMenu-styles__groupPopover",
  "menu": "meepshop-meep-ui__submenu-dropdownMenu-styles__menu",
  "menuItem": "meepshop-meep-ui__submenu-dropdownMenu-styles__menuItem",
  "arrow": "meepshop-meep-ui__submenu-dropdownMenu-styles__arrow"
};

var MenuGroup = function MenuGroup(_ref) {
  var page = _ref.page,
      menuSettings = _ref.menuSettings,
      ContentComponent = _ref.ContentComponent;

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page, {
    menuSettings: menuSettings
  }),
      title = _useButtonSettings.title,
      isActive = _useButtonSettings.isActive,
      url = _useButtonSettings.url,
      target = _useButtonSettings.target,
      isChildrenVisible = _useButtonSettings.isChildrenVisible;

  var renderButton = url ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: url,
    target: target,
    passHref: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    target: target,
    className: styles.menuItem,
    style: {
      fontWeight: isActive ? 'bold' : 'normal',
      fontSize: menuSettings.submenuFontSize || 'var(--submenu-font-size)'
    }
  }, title, isChildrenVisible && /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
    className: styles.arrow
  }))) : /*#__PURE__*/_react["default"].createElement("button", {
    className: styles.menuItem,
    type: "button"
  }, title, isChildrenVisible && /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
    className: styles.arrow
  }));
  return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    overlayClassName: styles.groupPopover,
    content: /*#__PURE__*/_react["default"].createElement(ContentComponent, {
      pages: page.pages,
      menuSettings: menuSettings,
      ContentComponent: ContentComponent
    }),
    placement: "rightTop",
    align: {
      offset: [-8, 0],
      targetOffset: [0, 0]
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, renderButton));
};

var _default = MenuGroup;
exports["default"] = _default;